module.exports = __webpack_public_path__ + "img/6.73583625.jpg";